export default __webpack_public_path__ + "static/media/barefootNomad.91aadc3f.png";